export default "__VITE_ASSET__CJ$hBjX2__"